<template>
    <div>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">预售仓明细</span>
                        <Checkbox v-model="amountFilter"
                            @on-change="onShowHasStockOnly">只看有仓存</Checkbox>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button type="success"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onEntry">预售入库单</Button>
                        <Button type="warning"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onTransformList">调拨单</Button>
                        <Button type="error"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="onAgentEntry">内部购销入库单</Button>
                        <Button type="error"
                            size='small'
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            ghost
                            @click="onClickImport()">导入</Button>
                        <Button type="info"
                            size='small'
                            class="btns"
                            shape="circle"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="storeList"
                    :loading="mainTable.tableLoading"
                    :extHeight="60"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="transformModal.show"
            :width="60"
            title="预售库调拨"
            class-name="vertical-center-modal">
            <Form label-position="top"
                class="small-form">
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="仓库">
                        <Input :value="transformModal.warehouseName"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="产品编号">
                        <Input :value="transformModal.productCode"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="产品名称">
                        <Input :value="transformModal.productName"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="批次号">
                        <Input :value="transformModal.transformBatchCode"
                            readonly></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="仓存量">
                        <Input :value="transformModal.Amount"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="销售期限">
                        <Input :value="transformModal.transformSalePeriod"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="过鲜日期">
                        <Input :value="formatDateTimeString(transformModal.expiredDate)"
                            readonly></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="入库价">
                        <Input :value="transformModal.transformPrice"
                            readonly></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="5">
                    <FormItem label="目标仓库">
                        <RadioGroup v-model="transformModal.transTarget">
                            <Radio label="现售仓">现售仓</Radio>
                            <Radio label="自用仓">自用仓</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col v-if="transformModal.transTarget==='现售仓'"
                        span="5">
                    <FormItem label="销售类型">
                        <RadioGroup v-model="transformModal.isPublic">
                            <Radio :label="1">公开</Radio>
                            <Radio :label="0">对内</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="4">
                    <FormItem label="调拨价">
                        <InputNumber v-model="transformModal.transformNewPrice"
                            :min="0"
                            :readonly="true"
                            style="width:100%;"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="4">
                    <FormItem label="调拨数量">
                        <InputNumber v-model="transformModal.transformAmount"
                            :max="transformModal.Amount"
                            :min="0"
                            style="width:100%;"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="备注">
                        <Input v-model="transformModal.transformRemark"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary"
                    :loading="btnLoading"
                    @click="onTransform">确认</Button>
                <Button type="error"
                    @click="transformModal.show=false">取消</Button>
            </div>
        </Modal>

        <Modal v-model="listModal.show"
            title="调拨单"
            :width="80"
            class-name="vertical-center-modal">
            <stand-pagination-table :columns="listModal.table.columns"
                :data="listModal.table.rows"
                :loading="listModal.table.loading"
                :table-search="listModal.table.tableSearch"
                :table-load-event="getTransformListRecord" />
            </Col>

        </Modal>

        <Modal v-model="importModel.show"
            title="请选择要导入的文件"
            :mask-closable="false"
            @on-ok="onImportEntry"
            :loading="true"
            width=300>
            <div style="display:flex;justify-content: space-between;">
                <Upload :show-upload-list="false"
                    :action="UPLOAD_FILE_API"
                    :format="['xlsx']"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError">
                    <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>

                <Button icon="ios-cloud-download-outline"
                    @click="downloadImportTemplate()">下载模板</Button>
            </div>
            <div>{{importModel.fileName}}</div>
        </Modal>

        <PreWarehouseEntryList ref="preWarehouseEntryListModal" />
        <PreSaleAgentWarehouseEntryList ref="preSaleAgentWarehouseEntryList" />
    </div>
</template>

<script>
import { currencyRender, dateRender } from '@/libs/tableRowTimeRender';
import CurrencyInput from '@/components/number-input/currency-input';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import PreWarehouseEntryList from './../../preSale-management/preSale-warehouse-entry/preSale-warehouse-entry-list';
import PreSaleAgentWarehouseEntryList from './../../preSale-management/preSale-warehouse-entry/preSale-agent-warehouse-entry-list';
import { getPreSaleWarehouseProductStore } from '@/api/modules/warehouse-management/warehouse';
import { transformWarehouseEntry, getWarehouseTransformList } from '@/api/modules/warehouse-management/warehouseEntry';
import { formatDateTimeString } from '@/libs/logic';
import { DOWNLOAD_SERVER, UPLOAD_FILE_API } from '@/api/modules/files';
import { importWarehouseEntry } from '@/api/modules/warehouse-management/warehouseEntry';

export default {
    name: 'PreSaleWarehouseStore',
    components: {
        CurrencyInput,
        StandPaginationTable,
        SearchCard,
        PreWarehouseEntryList,
        PreSaleAgentWarehouseEntryList
    },
    data() {
        return {
            UPLOAD_FILE_API,
            amountFilter: true,
            btnLoading: false,
            mainTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', width: 140, align: 'center', excel: true },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center', excel: true },
                    { title: '产品名称', key: 'productName', width: 80, align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', width: 100, align: 'center', excel: true },
                    { title: '批次号', key: 'warehouseProductStoreBatchCode', width: 100, align: 'center', excel: true },
                    { title: '入库量', key: 'entryAmount', width: 80, align: 'center', excel: true },
                    { title: '发货量', key: 'deliveryAmount', width: 80, align: 'center', excel: true },
                    { title: '调拨量', key: 'transferAmount', width: 80, align: 'center', excel: true },
                    { title: '仓存量', key: 'warehouseProductStoreAmount', width: 80, align: 'center', excel: true },
                    { title: '销售期限', key: 'warehouseProductStoreSalePeriod', width: 80, align: 'center', excel: true },
                    { title: '过鲜日期', key: 'warehouseProductStoreExpireDate', width: 80, align: 'center', excel: true, render: (h, params) => dateRender(h, params.row.warehouseProductStoreExpireDate) },
                    { title: '入库价', key: 'warehouseProductStoreBatchPrice', width: 80, align: 'center', excel: true, render: (h, params) => currencyRender(h, params.row.warehouseProductStoreBatchPrice) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return '';
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                        },
                                        on: {
                                            click: () => {
                                                this.onClickTransfer(params.row);
                                            }
                                        }
                                    }, '调拨')
                                ]);
                            }
                        }
                    }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' },
                    // { label: '产品名称', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    { label: '批次号', type: 'Input', value: '', name: 'warehouseProductStoreBatchCode', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ]
            },
            storeList: [],
            transformModal: {
                show: false,
                warehouseName: '',
                transformWarehouseUuid: '',
                transformProductUuid: '',
                productCode: '',
                productName: '',
                transformBatchCode: '',
                Amount: 0,
                transformSalePeriod: 0,
                expiredDate: '',
                price: 0,
                transformAmount: 0,
                transformPrice: 0,
                transformNewPrice: 0,
                transformRemark: '商品调拨',
                transTarget: '现售仓',
                isPublic: 1
            },
            listModal: {
                show: false,
                table: {
                    rows: [],
                    columns: [
                        { title: '单号', key: 'warehouseEntryTransformRecordBillCode', width: 150, align: 'center' },
                        { title: '目标仓', key: 'warehouseEntryTransformRecordTarget', align: 'center' },
                        { title: '产品编号', key: 'warehouseEntryTransformRecordProductCode', align: 'center' },
                        { title: '产品名称', key: 'warehouseEntryTransformRecordProductName', align: 'center' },
                        { title: '批次号', key: 'warehouseEntryTransformRecordBatchCode', align: 'center' },
                        { title: '调拨量', key: 'warehouseEntryTransformRecordAmount', align: 'center' },
                        { title: '经办', key: 'warehouseEntryTransformRecordOperator', align: 'center' },
                        { title: '调拨时间', key: 'warehouseEntryTransformRecordCreatedAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseEntryTransformRecordCreatedAt) },
                        { title: '备注', key: 'warehouseEntryTransformRecordRemark', align: 'center' }
                    ],
                    loading: false,
                    tableSearch: search.getSearchParams()
                }
            },
            importModel: {
                show: false,
                loading: false,
                fileWebName: '',
                fileName: ''
            }
        };
    },
    created() {
        if (this.$checkAccessArray(["B", "C"]) === false) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getMainTableRecords();
    },
    methods: {
        formatDateTimeString,
        handleSuccess(res, file) {
            this.importModel.fileWebName = res.data.fileList[0].fileUuid;
            this.importModel.fileName = res.data.fileList[0].fileName;
        },
        handleFormatError(file) {
            const str = this.format.join(', ');
            this.$Notice.warning({
                title: '文件格式错误',
                desc: '请选择 ' + str + ' 后缀的文件.'
            });
        },
        onClickImport() {
            this.importModel.fileName = '';
            this.importModel.fileWebName = '';
            this.importModel.show = true;
        },
        onImportEntry() {
            importWarehouseEntry({ importFileName: this.importModel.fileWebName }).then(res => {
                this.importModel.show = false;
                if (res.code === 0) {
                    this.getMainTableRecords();
                    this.$Modal.success({
                        title: '导入成功',
                        content: ''
                    });
                }
            });
        },
        downloadImportTemplate() {
            let url = DOWNLOAD_SERVER + 'Import/template/presale_entry_import_template.xlsx';
            this.$downLoadFile(url);
            // window.open(FILE_SERVER + "Import/template/presale_entry_import_template.xlsx", "_blank");
        },
        onExport() {
            const searchCondition = search.deepClone(this.mainTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.tableLoading = true;
            getPreSaleWarehouseProductStore(searchCondition).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        onEntry() {
            this.$refs.preWarehouseEntryListModal.showModal();
        },
        onAgentEntry() {
            this.$refs.preSaleAgentWarehouseEntryList.showModal();
        },
        onTransformList() {
            this.listModal.show = true;
            this.getTransformListRecord();
        },
        getTransformListRecord() {
            this.listModal.table.loading = true;
            this.listModal.table.tableSearch.source = "预售仓";
            getWarehouseTransformList(this.listModal.table.tableSearch).then(res => {
                this.listModal.table.loading = false;
                this.listModal.table.rows = res.data.records;
                search.globalSetFilterRecordCount(this.listModal.table.tableSearch, res.data.filterRecordCount);
            });
        },
        onClickTransfer(row) {
            // console.log(row);
            this.transformModal.transformProductUuid = row.warehouseProductStoreProductUuid;
            this.transformModal.transformWarehouseUuid = row.warehouseProductStoreWarehouseUuid;
            this.transformModal.productCode = row.productCode;
            this.transformModal.productName = row.productName;
            this.transformModal.warehouseName = row.warehouseName;
            this.transformModal.transformBatchCode = row.warehouseProductStoreBatchCode;
            this.transformModal.Amount = row.warehouseProductStoreAmount;
            this.transformModal.transformSalePeriod = row.warehouseProductStoreSalePeriod;
            this.transformModal.expiredDate = row.warehouseProductStoreExpireDate;
            this.transformModal.transformPrice = row.warehouseProductStoreBatchPrice;
            this.transformModal.transformNewPrice = row.transformNewPrice;
            this.transformModal.transformAmount = 0;
            this.transformModal.tranformRemark = '';
            this.transformModal.show = true;

        },
        onTransform() {
            if (this.transformModal.transformAmount > this.transformModal.Amount) {
                this.$Modal.error({ title: '出错啦', content: '调拨数量不能大于仓存量' });
                return;
            }
            this.btnLoading = true;
            transformWarehouseEntry(this.transformModal).then(res => {
                this.btnLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '调拨成功',
                        onOk: () => {
                            this.transformModal.show = false;
                            this.getMainTableRecords();
                        }
                    });
                }
            });
        },
        onShowHasStockOnly() {
            this.getMainTableRecords(true);
        },
        getMainTableRecords(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.amountFilter = this.amountFilter ? 1 : 0;
            this.mainTable.tableLoading = true;
            getPreSaleWarehouseProductStore(this.mainTable.tableSearch).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    this.storeList = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);

                    let totalAmount = 0;
                    this.storeList.forEach(e => {
                        totalAmount += e.warehouseProductStoreAmount;
                        e.transformNewPrice = e.warehouseProductStoreBatchPrice;
                    });
                    this.storeList.push({
                        warehouseProductStoreAmount: totalAmount,
                        transferAmount: '合计',
                        action: -1,
                        warehouseProductStoreBatchPrice: null
                    });
                }
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
